import {useAppSelector} from './redux';

export const useGetAmsIconName = () => {
  const emoduleTypeIconName = useAppSelector(
    ({assets}) => assets.emoduleTypeIconName
  );

  const getAmsIconName = (
    type: number | null,
    ava: 1 | 0 = 0,
    non_sensing: number = 0
  ) => {
    if (!!ava && !!non_sensing) {
      return 'ava';
    }
    return typeof type === 'number' && emoduleTypeIconName?.[type]
      ? emoduleTypeIconName?.[type]
      : 'unknown';
  };

  return getAmsIconName;
};
